var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-4 pa-3 text-center",attrs:{"color":_vm.color},on:{"click":function($event){_vm.action !== null ? _vm.action : null}}},[_c('h2',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.title)),_c('br'),_vm._v(" "),(_vm.value)?_c('span',[_vm._v(_vm._s(_vm.value))]):_c('span',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }